import { gql, useMutation } from "@apollo/client"

const CONTACT_US = gql`
  mutation contactUs(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String
    $company: String
    $title: String
    $message: String
  ) {
    contactUs(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      company: $company
      title: $title
      message: $message
    ) {
      success
    }
  }
`

interface ContactUsMutation {
  contactUs: {
    success: boolean
  }
}

export const useContactUs = () => {
  const [contactUs, { data, loading, error }] = useMutation<ContactUsMutation>(CONTACT_US)
  return { contactUs, data, loading, error }
}
